// extracted by mini-css-extract-plugin
export var dateLabel = "_2j-0";
export var dateLabelError = "_2j-1";
export var fullWidth = "_2j-2";
export var smaller = "_2j-3";